import { i18nMark } from 'lingui-react';

const messages = {
  item: i18nMark('Item'),
  value: i18nMark('Value'),
  measure: i18nMark('Measure'),
  other: i18nMark('Other'),
  relatedFaults: i18nMark('Related Faults ({count})'),
};

export default messages;



// WEBPACK FOOTER //
// ./compositions/DiagnosticsWidget/DiagnosticsComponent/CaseFault/FaultDetails/messages.js